import { Box, Tooltip } from '@mui/material';
import { chains } from 'src/assets/data';

const XChainField = ({ value, sx }: { value: [] | number; sx?: object }) => {

  // Chuyển đổi thành array
  const chainIds = Array.isArray(value) ? value : [value];
  if (chainIds.length === 0) return null;

  // Lấy tên chain từ id hoặc sử dụng trực tiếp nếu là string
  const chainNames = chainIds
    .map((id) => {
      const chainId = typeof id === 'number' ? id : parseInt(id as string, 10);
      const chain = chains.find((c) => c.id === chainId);
      return chain?.name?.toLowerCase() || '';
    })
    .filter(Boolean);

  if (chainNames.length === 0) return null;

  // Hiển thị tối đa 2 chain, nếu > 3 thì hiện 2 + badge số còn lại
  const displayChains = chainNames.length > 3 ? chainNames.slice(0, 2) : chainNames.slice(0, 3);
  const remainingCount = chainNames.length - displayChains.length

  return (
    <Box display="flex" alignItems="center" gap={0.5} sx={sx}>
      {displayChains.map((chainName) => (
        <Tooltip key={chainName} title={chainName}>
          <Box
            component="img"
            src={`/icons/chains/${chainName}.png`}
            alt={chainName}
            sx={{
              width: '20px',
              height: '20px',
              borderRadius: '100%',
            }}
          />
        </Tooltip>
      ))}
      {remainingCount > 0 && (
        <Tooltip title={`+${remainingCount} more chain${remainingCount > 1 ? 's' : ''}`}>
          <Box
            sx={{
              width: '20px',
              height: '20px',
              borderRadius: '100%',
              backgroundColor: 'var(--palette-background-neutral)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            +{remainingCount}
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default XChainField;
